type Config = {
	readonly host: string;
	readonly backupHost: string;
	readonly centralizedHost: string;
	readonly apiKey: string;
	readonly env: string;
	readonly useRemoteConfig: boolean;
	readonly firebase: {
		readonly apiKey: string;
		readonly authDomain: string;
		readonly projectId: string;
		readonly storageBucket: string;
		readonly messagingSenderId: string;
		readonly appId: string;
		readonly measurementId: string;
	};
};

const useRemoteConfig = Boolean(process.env.VUE_APP_USE_REMOTE_CONFIG);

const config: Config = {
	host: useRemoteConfig
		? (localStorage.getItem('host') ?? process.env.VUE_APP_HOST_UNIKUME_KINKANDO)
		: process.env.VUE_APP_HOST_UNIKUME_KINKANDO,
	backupHost: process.env.VUE_APP_HOST_UNIKUME_KINKANDO_BACKUP,
	centralizedHost: process.env.VUE_APP_HOST_CENTRALIZED,
	apiKey: process.env.VUE_APP_API_KEY_UNIKUME_KINKANDO,
	env: process.env.VUE_APP_ENV,
	useRemoteConfig,
	firebase: {
		apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
		authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
		projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
		storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
		messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
		appId: process.env.VUE_APP_FIREBASE_APP_ID,
		measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
	}
};

export { config };
